module.exports = __webpack_public_path__ + "img/logo.a8e1528d.jpg";